import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  // Scoped to the form: the discussion panel's message editor is a .tiptap-editor too.
  $(document).on('focus', '.design-rationale .tiptap-editor', () => {
    $('.design-rationale__button-container').show();
    if ($('.design-rationale__rationale').text().trim().length) {
      $('.design-rationale__rationale').hide();
    }
  });

  $(document).on('click', '.design-rationale__edit-link', (e) => {
    $(e.target).hide();
    $('.design-rationale__rationale').hide();
    $('.design-rationale__button-container').show();
    $('.design-rationale__editor-container')
      .removeClass('hide')
      .show()
      .find('[contenteditable]')
      .focus();

    return false;
  });

  $(document).on('click', '.design-rationale__cancel-link', () => {
    if ($('.design-rationale__text').text() === '') {
      $('.design-rationale__button-container').hide();
    } else {
      $('.design-rationale__editor-container').hide();
      $('.design-rationale__button-container').hide();
      $('.design-rationale__rationale').show();
      $('.design-rationale__edit-link').css('display', 'inline-block');
    }
    return false;
  });

  $(document).on('submit', '.design-rationale', (e) => {
    const $form = $(e.target);
    const $submit = $form.find('button[type=submit]');

    const editorSelector = '.tiptap-editor [contenteditable]';
    const rationale = $(editorSelector).html();

    $('.design-rationale__field').val(rationale);

    if (!rationale) {
      return false;
    }

    $submit.prop('disabled', true).addClass('button-loading');

    $.post($form.attr('action'), $form.serialize(), () => {
      $submit.prop('disabled', false).removeClass('button-loading');
      $('.design-rationale__edit-link').css('display', 'inline-block');
      $('.design-rationale__text').html(rationale);
      $('.design-rationale__editor-container').hide();
      $('.design-rationale__link').addClass('hide');
      $('.design-rationale__rationale').show();
      $('.design-rationale__button-container').hide();
      $('.design-rationale__text-container').show();
      if (150 < $('.design-rationale__text').outerHeight()) {
        $('.design-rationale__link')
          .removeClass('hide')
          .removeClass('design-rationale__link--less')
          .addClass('design-rationale__link--more')
          .click();
      } else {
        $('.design-rationale__link').addClass('hide');
        $('.design-rationale__text-container').removeClass(
          'design-rationale__text-container--more'
        );
      }
      if ($(rationale).text() === '') {
        $('.design-rationale__text-container').hide();
      }
    });
    return false;
  });

  const showDesignRationale = () => {
    // Fixed threshold: the v2 sidebar lifts the container's max-height at xl, and this runs once.
    if ($('.design-rationale__text').outerHeight() > 130) {
      $('.design-rationale__text-container').addClass('design-rationale__text-container--more');
      $('.design-rationale__link').addClass('design-rationale__link--more').removeClass('hide');
    }
    $('.design-rationale__rationale').css('opacity', 1);
  };

  $(document).ready(showDesignRationale);

  $(document).on('click', '.design-rationale__link', () => {
    $('.design-rationale__link')
      .toggleClass('design-rationale__link--more')
      .toggleClass('design-rationale__link--less');
  });

  $(document).on('click', '.design-rationale__link--more', () => {
    const textHeight = $('.design-rationale__text').height() + 50;
    // style.setProperty, not .css(): jQuery before 3.2 ignores custom properties.
    $('.design-rationale__text-container').each((_, el) =>
      el.style.setProperty('--design-rationale-max-height', `${textHeight}px`)
    );
    $('.design-rationale__text-container').removeClass('design-rationale__text-container--more');
    return false;
  });

  $(document).on('click', '.design-rationale__link--less', () => {
    $('.design-rationale__text-container').each((_, el) =>
      el.style.removeProperty('--design-rationale-max-height')
    );
    $('.design-rationale__text-container').addClass('design-rationale__text-container--more');
    return false;
  });
});
